import { toast } from "react-toastify";

export function toastSettingsError(err: unknown, fallback: string) {
  const ax = err as { response?: { data?: { message?: string } } };
  toast.error(ax.response?.data?.message ?? fallback);
}
